import { Component, OnInit} from '@angular/core';
import {animate, style, transition, trigger} from '@angular/animations';
import {ModalDialogV3} from '../../../../shared-modal-dynamic/models/modal-dialog-v3';

@Component({
    selector: 'app-strip-modal',
    templateUrl: './strip-modal.component.html',
    styleUrls: ['./strip-modal.component.scss'],
    animations: [
        trigger('fade', [
            transition(':enter', [
                style({opacity: '0'}),
                animate('300ms', style({opacity: '1'}))
            ]),
            transition(':leave', [
                style({opacity: '1'}),
                animate('300ms', style({opacity: '0'}))
            ])
        ])
    ]
})
export class StripModalComponent extends ModalDialogV3 implements OnInit {

    public message: string;
    public isVisible = true;

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.message = this.modalParams.model['message'];
    }


    onStripClicked() {
        this.fadeClose();
    }

    public fadeClose() {
        this.isVisible = false;
        setTimeout(_ => {
            this.close();
        }, 300);
    }
}
